export default {
    message: {
        currencySymbol: "$",
        currencyDesc: "美元",
        tiers: {
            t1: {
                label: "Workspace Standard",
                desc: "<p>适用于使用 SaaS、Web 应用程序及文件共享服务的现代员工的带有智能功能的核心工作空间。</p><p>包括 SSO，支持针对所有应用程序采用多因素身份验证；含微应用程序、个性化信息推送和虚拟帮助的工作空间智能；以及提供无限文件存储的 Citrix Content Collaboration 标准服务。</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>适用于需要具有精细安全性的全数字化工作空间，但不需要虚拟应用与桌面的员工的完整工作空间解决方案。</p><p>包括 Workspace Standard 功能，以及针对 SaaS 和 web 的高端安全控件、统一的端点管理和 Content Collaboration Premium。</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>包括 Citrix Virtual Apps and Desktops 混合部署选项的全面的工作空间解决方案。</p><p>包括 Workspace Premium 功能，以及适用于 Citrix Virtual Apps and Desktops 的云管理选项。</p>"
            },
            t4: {
                label: "Workspace Essentials",
                desc: "<p>Citrix Workspace Essentials 通过简化和保护 SaaS 和网络应用程序的登录过程，帮助中小型企业保护数据。</p><p>包括采用多因素身份验证方式单点登录至 SaaS 和网络应用程序，以进一步保护登录过程，帮助将帐户遭到入侵的几率降低 99.9%。</p>"
            },
            terms: "*每用户每月",
            btn1: "查看功能列表"
        },
        features: {
            disclaimer1: "*订阅 3 年的 500 位用户的每用户每月 MSRP 美元。实际定价可能有所不同。<br /> Citrix Workspace 许可选项（许可的最低用户数为 25 名）。",
            disclaimer2: "**工作空间高级服务不包括面向内部 Citrix Virtual Apps and Desktops 部署的工作空间分析。"
        },
        calculator: {
            edition: "选择版本",
            title: "计算定价",
            users: "选择用户",
            estCost: "每月估算成本",
            btn1: "与专家交谈",
            btn1_link: "/products/citrix-workspace/form/pricing-inquiry/",
            minUserMsg: "许可选项（许可的最低用户数为 25 名）。请重试。",
            lowUserMsg: "不足 500 名用户？ 我们可以帮助满足中小型企业需求。",
            volumeDiscount: "超过 2500 名用户？ 享受批量折扣价格。",
            contract1: "1 年合同",
            contract3: "3 年合同",
            contract3savings: "节省 20%",
            term: "每用户每月",
            disclaimer: "*此计算器提供的为估计价格，仅用于预算目的。实际价格可能会有所不同。联系 Citrix 团队或合作伙伴，获取适用的折扣。"
        },
        stats: {
            title: "您获得的好处",
            stat1: {
                title: "改善员工体验",
                desc: "<b>五分之四</b>的 IT 领导者认为员工体验对数字转型至关重要。"
            },
            stat2: {
                title: "给予员工选择",
                desc: "<b>78%</b> 的企业领导认同让员工选择他们使用的应用程序和设备有助于改善员工体验。"
            },
            stat3: {
                title: "简化访问",
                desc: "<b>47%</b> 的企业领导表示，对员工敬业度做出最大贡献的是能够轻松获取完成工作所需的信息。"
            },
            btn1: "与专家交谈",
            disclaimer: "来源：<a href='https://theexperienceofwork.economist.com/Citrix_The_Experience_of_Work_BriefingPaper.pdf' target='_blank'>《经济学人》</a>"
        }
    }
}